export class CategoryDescListModel {
    category_no: number 
    category_code: string 

    constructor(
        category_no: number, 
        category_code: string, 
    ) {
        this.category_no = category_no 
        this.category_code = category_code 
    }
} 